export default __webpack_public_path__ + "static/media/main_footer_bug.2b71136a.svg";